import React, { ReactNode } from "react";
import { Button } from "@mui/material";
import isMobile from "is-mobile";
import theme from "../../../../styles/theme";

export type ActionButtonProps = {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  href?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  rel?: string;
  disabled?: boolean;
  fullWidth?: boolean;
};

export const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  icon,
  href,
  target = "_blank",
  rel = "noopener noreferrer",
  disabled = false,
  fullWidth = false,
}) => {
  return (
    <Button
      startIcon={icon}
      variant="contained"
      onClick={onClick}
      {...(href
        ? {
            href,
            target,
            rel,
          }
        : {})}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{
        backgroundColor: theme.colors.blue.primary,
        borderRadius: "52px",
        height: "35px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontFamily: theme.fonts.gilroyBold,
        width: fullWidth ? "100%" : "fit-content",
        paddingInline: isMobile() ? "4.5vw" : "1.5vw",
        textTransform: "none",
        transition: "background-color 0.3s ease",
        lineHeight: "15px",
        "&:hover": {
          color: "white",
        },
      }}
    >
      {label}
    </Button>
  );
};

export default ActionButton;
